(() => {
  angular.module('pims').directive('openChat', ["$log", "ngDialog", "Messages", ($log, ngDialog, Messages) => {
    'ngInject';

    return {
      restrict: 'A',

      link(scope, element, attrs) {
        const patientId = scope.$eval(attrs.openChat);
        element.on('click', () => Messages.openChat(patientId));
        scope.$on('$destroy', () => element.off());
      }

    };
  }]);
})();